import ContentSeparator from "components/ContentSeparator";
import Stack from "components/Stack";
import Text from "components/Text";

import ScheduleTable from "entities/Deal/components/OverviewSchedule/ScheduleTable";
import { useDealScheduleManager } from "entities/Memo/utils";

interface IPrintableOverviewSchedule {
  dealId: number;
  externalToken?: string;
}

const PrintableOverviewSchedule = ({
  dealId,
  externalToken,
}: IPrintableOverviewSchedule) => {
  const { data: schedule } = useDealScheduleManager({
    dealId,
    token: externalToken,
  });

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between">
        <Text variant="h2" data-testid="section-header-name">
          Schedule
        </Text>
      </Stack>

      <ContentSeparator label="Schedule" />
      {schedule && <ScheduleTable schedule={schedule} />}
    </Stack>
  );
};

export default PrintableOverviewSchedule;
